import { CourseService } from 'src/app/core/services/course.service';
import { take, takeUntil } from 'rxjs/operators';
import { Category } from './../../core/models/category';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from './../../components/base/base.component';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BaseService } from 'src/app/core/services/base.service';
import { AlertService } from 'src/app/core/services/alert.service';
import { Course } from 'src/app/core/models/course';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent extends BaseComponent implements OnInit {
  categories: Category[];

  categoriesNo: number;
  courseCount: number;
  studentCount: number;
  teacherCount: number;

  topRatedCourse: Course[] = [];

  loader = true;

  lange: string;

  constructor(
    private router: Router,
    public translate: TranslateService,
    public baseService: BaseService,
    private alertService: AlertService,
    private route: ActivatedRoute,
    private courseService: CourseService
  ) { super() }

  ngOnInit(): void {

    setTimeout(() => {
      this.router.navigate(['/home']);
    }, 300);

    if (!localStorage.getItem('up')) {
      localStorage.setItem('up', 'no reload');
      location.reload();
    } else {
      localStorage.removeItem('up');
    }

    // this.loadData();
    this.courseService.getDashBoard().pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      (data: any) => {

        this.categoriesNo = data.result.returnData.categories;
        this.courseCount = data.result.returnData.courseCount;
        this.studentCount = data.result.returnData.studentCount;
        this.teacherCount = data.result.returnData.teacherCount;
        // console.log(this.teacherCount);
      }
    )

    this.courseService.getTopRatedCourses().pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      (data: any) => {
        this.topRatedCourse = data.result.returnData;
        // console.log(this.topRatedCourse);
      }
    )

    this.loader = false;
  }

  openDetail(id) {
    this.router.navigate(['/course-details/edit', id]);
  }

  // loadData(){
  //   this.route.data.pipe(takeUntil(this.ngUnsubscribe)).subscribe(
  //     data=>{
  //       // this.categories = data.categories.result.returnData;
  //       // console.log(this.categories);
  //     });
  // }

}
